import React from 'react';
import PropTypes from 'prop-types';

import IconSadFace from 'components/icons/iconSadFace';

const CollectionsGridEmpty = ({ clearFilters }) => (
  <div className="px-[3.333vw] py-8 relative">
    <div className="inline-block align-top mr-[2.7rem]">
      <IconSadFace />
    </div>

    <div className="inline-block">
      <h4 className="text-xl font-bold text-gray mb-[9px]">
        Unfortunately, none of our collections match that criteria.
      </h4>
      <div className="text-base font-bold text-gray">
        Please try a different combination of filters.
      </div>
      <button
        className="rounded-[20px] bg-[rgba(216,98,98,.1)] text-red pt-[7px] pr-[21px] pb-[7px] pl-[35px] relative border-0 mt-3.5 cursor-pointer [&_i]:absolute [&_i]:left-5 [&_i]:top-1/2 [&_i:after]:[content:''] [&_i:after]:absolute [&_i:after]:w-[15px] [&_i:after]:h-px [&_i:after]:bg-red [&_i:after]:rounded-sm [&_i:after]:top-1/2 [&_i:after]:transition-[all_.3s] [&_i:before]:[content:''] [&_i:before]:absolute [&_i:before]:w-[15px] [&_i:before]:h-px [&_i:before]:bg-red [&_i:before]:rounded-sm [&_i:before]:top-1/2 [&_i:before]:transition-[all_.3s] [&_i:before]:rotate-45 [&_i:before]:left-1/2 [&_i:before]:ml-[-7.5px] [&_i:before]:-mt-px [&_i:before]:text-red [&_i:after]:-rotate-45 [&_i:after]:right-1/2 [&_i:after]:mr-[-7.5px] [&_i:after]:-mt-px [&_i:after]:text-red"
        onClick={clearFilters}
        type="button"
      >
        <i />
        Clear all
      </button>
    </div>
  </div>
);

CollectionsGridEmpty.propTypes = {
  clearFilters: PropTypes.func.isRequired,
};

export default CollectionsGridEmpty;
